import { ASSETS_ROOT } from "../AssetsUtils";
import { BaseCoreImageLoader } from "./_BaseImageLoader";
import { TextureLoader } from "three";
export class ImageDefaultTextureLoader extends BaseCoreImageLoader {
  constructor(_url, _node) {
    super(_url, _node);
  }
  async _getLoader(options) {
    const loader = new TextureLoader(this.loadingManager);
    return loader;
  }
}
ImageDefaultTextureLoader.PARAM_DEFAULT = `${ASSETS_ROOT}/textures/uv.jpg`;
